import { FC } from 'react';
import { PageViewMode, usePageViewMode } from '../../hooks/usePageViewMode';
import { NoPermissions } from '../NoPermissions';

type PageComponent = FC<{
  viewMode: ViewMode,
}>

export const WithPageViewModes = (Component: PageComponent, viewModes: PageViewMode[]): FC => {
  const Page: FC = (): JSX.Element | null => {
    const viewMode = usePageViewMode(viewModes);

    if (!viewMode) {
      return <NoPermissions />;
    }
  
    return <Component viewMode={ viewMode } />;
  };

  return Page;
};
